
import React, { useEffect } from 'react';

export const RateCardBasicChargeActionComponent = ({ vehicle,
    delivery,
    rto,
    fuel,
    peakSeason,
    toll }: any) => {
    const rent = vehicle ? 200 : null
    const total = [delivery, rto, fuel, peakSeason, toll, rent]
        .map(value => Number(value) || 0) // Convert all values to numbers, default to 0 if invalid
        .reduce((acc, curr) => acc + curr, 0); // Sum all valid numbers


    return (


        <div className="max-w-md mx-auto p-4 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Basic Charges</h2>

            {/* Table for displaying charges */}
            <table className="w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border px-4 py-2">Basic</th>
                        <th className="border px-4 py-2">Charges(₹)</th>
                    </tr>
                </thead>
                <tbody>
                    {vehicle &&
                        <tr className="text-center">
                            <td className="border px-4 py-2">Vehicle Rent
                                <div className='text-black text-opacity-50 text-xs'>(The price may vary depending on the vehicleType)</div>

                            </td>
                            <td className="border px-4 py-2">200</td>
                        </tr>}
                    {delivery &&
                        <tr className="text-center">
                            <td className="border px-4 py-2">Delivery</td>
                            <td className="border px-4 py-2">{delivery}</td>
                        </tr>}
                    {rto &&
                        <tr className="text-center">
                            <td className="border px-4 py-2">RTO</td>
                            <td className="border px-4 py-2">{rto}</td>
                        </tr>}
                    {fuel &&
                        <tr className="text-center">
                            <td className="border px-4 py-2">Fuel</td>
                            <td className="border px-4 py-2">{fuel}</td>
                        </tr>}
                    {peakSeason &&
                        <tr className="text-center">
                            <td className="border px-4 py-2">PeakSeason</td>
                            <td className="border px-4 py-2">{peakSeason}</td>
                        </tr>}
                    {toll &&
                        <tr className="text-center">
                            <td className="border px-4 py-2">Toll</td>
                            <td className="border px-4 py-2">{toll}</td>
                        </tr>}

                    <tr className="text-center bg-sky-200">
                        <td className="border px-4 py-2">Total</td>
                        <td className="border px-4 py-2">{total}</td>
                    </tr>
                </tbody>
            </table>
        </div>


    )
}
export default RateCardBasicChargeActionComponent;
